__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/34ed3e982903fe93a9e1a6db7b49e835be4b36d0/_next/";